"use strict";
/** @module @wattpad/client-platform-web-ads */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowAd = exports.AD_ELIGIBLE_PAID_STORY_IDS = exports.getOutstreamAd = exports.getAfpClientid = exports.includeAdMarkup = exports.createUniqueAdId = exports.getAd = exports.setupAdListener = void 0;
var helpers_1 = require("./helpers");
var loadAd_1 = require("./ads-growth/ads-service/helpers/loadAd");
var includeAdMarkup_1 = __importDefault(require("./helpers/includeAdMarkup"));
exports.includeAdMarkup = includeAdMarkup_1.default;
var isAdvertiserSafe_1 = __importDefault(require("./helpers/isAdvertiserSafe"));
var generateAndRenderHardcodedCreative_1 = __importDefault(require("./ads-growth/ads-service/utils/generateAndRenderHardcodedCreative"));
var refreshAd_1 = __importDefault(require("./ads-growth/ads-service/utils/refreshAd"));
var clientSupportsIO_1 = __importDefault(require("./ads-growth/ads-service/utils/clientSupportsIO"));
var getOutstreamAd_1 = __importDefault(require("./ads-growth/ads-service/helpers/getOutstreamAd"));
exports.getOutstreamAd = getOutstreamAd_1.default;
var getPlacementFromAdUnitId_1 = __importDefault(require("./ads-growth/ads-service/utils/getPlacementFromAdUnitId"));
var placementUtils_1 = require("./helpers/placementUtils");
var setupKevelImpressionListener_1 = __importDefault(require("./ads-growth/ads-service/utils/setupKevelImpressionListener"));
var getAfpClientid_1 = __importDefault(require("./ads-growth/ads-service/helpers/getAfpClientid"));
exports.getAfpClientid = getAfpClientid_1.default;
var adEligiblePaidStoryIds_1 = require("./ads-growth/ads-service/config/adEligiblePaidStoryIds");
Object.defineProperty(exports, "AD_ELIGIBLE_PAID_STORY_IDS", { enumerable: true, get: function () { return adEligiblePaidStoryIds_1.AD_ELIGIBLE_PAID_STORY_IDS; } });
var shouldShowAd_1 = __importDefault(require("./helpers/shouldShowAd"));
exports.shouldShowAd = shouldShowAd_1.default;
/**
 * Setup a global event listener to listen out for events with the type "ad-service-event".
 * This is necessary to setup before any consumer users the {@link getAd} functionality,
 * so that the client-platform-web-ads module knows when to ask the ads-growth module for an advertisement.
 *
 * @example <caption>Example usage for environments supporting import</caption>
 * import { setupAdListener } from "@wattpad/client-platform-web-ads";
 * ...
 * setupAdListener();
 */
function setupAdListener() {
    if (helpers_1.canUseDom) {
        window.addEventListener("ad-service-event", adEvent);
        if (document.readyState !== "loading") {
            (0, setupKevelImpressionListener_1.default)();
        }
        else {
            window.addEventListener("DOMContentLoaded", setupKevelImpressionListener_1.default);
        }
    }
}
exports.setupAdListener = setupAdListener;
function adEvent(e) {
    var _a, _b, _c, _d, _e;
    var adContext = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.context;
    var testGroups = (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.testGroups;
    var userGeo = (_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.userGeo;
    var userDeviceType = (_d = e === null || e === void 0 ? void 0 : e.detail) === null || _d === void 0 ? void 0 : _d.deviceType;
    var placementWithTimestamp = (_e = e === null || e === void 0 ? void 0 : e.detail) === null || _e === void 0 ? void 0 : _e.placement;
    var placement = (0, getPlacementFromAdUnitId_1.default)(placementWithTimestamp);
    // Double check if user is premium or story is paid or if it's a ad exempt story
    var isContextAdExempt = (0, includeAdMarkup_1.default)(placement, testGroups, adContext);
    if (isContextAdExempt.result) {
        var isContextAdvertiserSafe = (0, isAdvertiserSafe_1.default)(placement, testGroups, adContext);
        if ((0, placementUtils_1.isPlacementDisabled)(placement)) {
            if ((0, helpers_1.getCookie)("debug-ads")) {
                console.log("ad placement ".concat(placementWithTimestamp, " is disabled: hardcoded creative"));
            }
            (0, generateAndRenderHardcodedCreative_1.default)(placementWithTimestamp);
        }
        else if (isContextAdvertiserSafe.result) {
            if ((0, helpers_1.getCookie)("debug-ads")) {
                console.log("".concat(isContextAdvertiserSafe.reason, ": displaying advertisement for ").concat(placementWithTimestamp));
            }
            (0, loadAd_1.loadAd)(placementWithTimestamp, testGroups, adContext, userGeo, userDeviceType);
        }
        else {
            if ((0, helpers_1.getCookie)("debug-ads")) {
                console.log("".concat(isContextAdvertiserSafe.reason, ": hardcoded creative for ").concat(placementWithTimestamp));
            }
            if (typeof window.__atha !== "undefined") {
                var story = adContext === null || adContext === void 0 ? void 0 : adContext.story;
                var storyPart = adContext === null || adContext === void 0 ? void 0 : adContext.storyPart;
                window.__atha.sendSkip(placementWithTimestamp, isContextAdvertiserSafe.reason, story, storyPart);
            }
            (0, generateAndRenderHardcodedCreative_1.default)(placementWithTimestamp);
        }
    }
    else {
        // If this code gets here. The ad placement was not implemented properly
        console.warn("".concat(isContextAdExempt.reason, ": Context was ad exempt but markup was generated"));
    }
}
/**
 * Takes a provided Ad Configuration and passes it off to the ads-growth module to request an advertisement to be displayed. An advertisement will be injected
 * into the DOM element matching the target placement, if the AdConfiguration provided passes all of the rule checks.
 * @param {IAdConfiguration} adConfiguration
 */
function getAd(adConfiguration, refresh) {
    var placement = adConfiguration.placement, context = adConfiguration.context, testGroups = adConfiguration.testGroups, deviceType = adConfiguration.deviceType, userGeo = adConfiguration.userGeo;
    if ((0, helpers_1.getCookie)("debug-ads")) {
        console.log("getAd called for ".concat(placement));
    }
    var placementName = (0, getPlacementFromAdUnitId_1.default)(placement);
    var refreshDetails = (0, placementUtils_1.getRefreshDetails)(placementName);
    // Double check if user is premium or story is paid or if it's an ad exempt story
    var shouldIncludeAdMarkup = (0, includeAdMarkup_1.default)(placementName, testGroups, context);
    if (shouldIncludeAdMarkup.result) {
        window.dispatchEvent(new CustomEvent("ad-service-event", {
            detail: { placement: placement, testGroups: testGroups, context: context, deviceType: deviceType, userGeo: userGeo },
        }));
        if (refresh) {
            return (0, refreshAd_1.default)(adConfiguration);
        }
        else if (refreshDetails === null || refreshDetails === void 0 ? void 0 : refreshDetails.refreshAd) {
            var intervalID_1;
            var timer_1 = 0;
            var refreshRate_1 = refreshDetails.refreshRate || 30; // number of seconds between refresh, default 30
            var refreshRemaining_1 = refreshDetails.maxRefreshes || 30; // remaining number of refreshes that should happen, default 30
            var timerTick_1 = 5; // number of seconds for the timer to tick
            var refreshCallback = function (entries, observer) {
                if ((0, helpers_1.getCookie)("debug-ads")) {
                    console.log("refreshCallback called for ".concat(placement));
                }
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        if ((0, helpers_1.getCookie)("debug-ads")) {
                            console.log("ad with placement ".concat(placement, " is on screen, starting timer"));
                        }
                        intervalID_1 = setInterval(function () {
                            if (!document.hasFocus() ||
                                document.visibilityState !== "visible") {
                                if ((0, helpers_1.getCookie)("debug-ads")) {
                                    console.log("document not in focus for ".concat(placement));
                                }
                            }
                            else {
                                timer_1 += timerTick_1;
                                if ((0, helpers_1.getCookie)("debug-ads")) {
                                    console.log("Time elapsed for ".concat(placement, ": ").concat(timer_1));
                                }
                                if (timer_1 >= refreshRate_1 && refreshRemaining_1 > 0) {
                                    timer_1 = 0;
                                    refreshRemaining_1--;
                                    if ((0, helpers_1.getCookie)("debug-ads")) {
                                        console.log("Refreshing ad with placement: ".concat(placement, ". Remaining refeshes: ").concat(refreshRemaining_1));
                                    }
                                    (0, refreshAd_1.default)(adConfiguration)();
                                }
                                if (refreshRemaining_1 <= 0) {
                                    clearInterval(intervalID_1);
                                    observer.unobserve(entry.target);
                                    if ((0, helpers_1.getCookie)("debug-ads")) {
                                        console.log("Removing observer due to max refreshes for ad with placement: ".concat(placement));
                                    }
                                }
                            }
                        }, timerTick_1 * 1000);
                    }
                    else {
                        if ((0, helpers_1.getCookie)("debug-ads")) {
                            console.log("ad with placement ".concat(placement, " is not on screen, stopping timer"));
                        }
                        clearInterval(intervalID_1);
                    }
                });
            };
            if ((0, clientSupportsIO_1.default)()) {
                // These are the options we use to refresh ads. The counter will tick when the
                // ad is 100% in the user's viewport
                var refreshAdOptions = {
                    root: null,
                    rootMargin: "0px 0px",
                    threshold: 1,
                };
                var adContainer = document.getElementById(placement);
                var observer = new IntersectionObserver(refreshCallback, refreshAdOptions);
                if (adContainer) {
                    observer.observe(adContainer);
                }
            }
        }
    }
}
exports.getAd = getAd;
/**
 * Generates a unique ID to attach to a DOM element and pass to getAd, so that the ads-growth module knows where to display the advertisement.
 *
 * @param {string} placement - an identifier that describes the type of ad and where it is intended to be displayed. See adPlacements module for all supported placement types.
 * @returns {string} placement postfixed with a unique-ish number based on the datetime to string.
 *
 * @example <caption>Usage in reactJS based frameworks</caption>
 * const uniquePlacement = createUniqueAdId(placement);
 * useEffect(() => {
 *   getAd(uniquePlacement, {}, context);
 * });
 * return <div id={uniquePlacement} />;
 */
function createUniqueAdId(placement) {
    if (!(0, placementUtils_1.isValidAdPlacement)(placement)) {
        throw new Error("Invalid placement: " + placement);
    }
    return placement + "-" + Date.now();
}
exports.createUniqueAdId = createUniqueAdId;
__exportStar(require("./eligibility"), exports);
exports.default = {
    setupAdListener: setupAdListener,
    getAd: getAd,
    getOutstreamAd: getOutstreamAd_1.default,
    createUniqueAdId: createUniqueAdId,
    includeAdMarkup: includeAdMarkup_1.default,
    getAfpClientid: getAfpClientid_1.default,
    shouldShowAd: shouldShowAd_1.default,
};
